export enum HeadingLevel {
  Heading1 = 1,
  Heading2 = 2,
  Subheading = 3,
  Label = 7,
}
